/* global fetchUrl, storeUrl, updateUrl, testConnectionUrl, checkConnection */

import React, { useState, useEffect, Fragment } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import IntegrationsSetupList from './IntegrationsSetupList';

export default function IntegrationsSetupIndex(props) {
    const [fetching, setFetching] = useState(false);
    const [categories, setCategories] = useState([]);
    const [providersByCategories, setProvidersByCategories] = useState({});
    const [activeTab, setActiveTab] = useState('ERP');

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        setFetching(true);
        axios
            .get(props.fetchUrl)
            .then((res) => {
                setProvidersByCategories(res.data.providersByCategories);
                setCategories(res.data.categories);
            })
            .catch((e) => {
                console.log(e?.response);
            })
            .finally(() => {
                setFetching(false);
            });
    };

    return (
        <div>
            <div className="tw-flex tw-flex-col tw-gap-6">
                <div className="tw-flex tw-flex-row tw-justify between tw-items-center">
                    <div
                        className="in-nav horizontal"
                        data-tabs-active-classes="active"
                        data-tabs-inactive-classes="inactive"
                        data-default-tab-id="erp-integrations-tab"
                        data-tabs-toggle="#erp-integrations-tab-content"
                        role="tablist"
                    >
                        {categories.map((category) => {
                            return (
                                <button
                                    key={`key-${category}`}
                                    className={`in-nav__item ${category === activeTab ? 'active' : 'inactive'}`}
                                    id={`${category}-tab`}
                                    data-tabs-target={`#${category}`}
                                    type="button"
                                    role="tab"
                                    aria-controls={`#${category}`}
                                    aria-selected={category === activeTab ? 'true' : 'false'}
                                    onClick={() => {
                                        setActiveTab(category);
                                    }}
                                >
                                    {category}
                                </button>
                            );
                        })}
                    </div>
                </div>

                <div id="erp-integrations-tab">
                    {categories.map((category) => {
                        return (
                            <Fragment key={`tab-${category}`}>
                                {category === activeTab && (
                                    <div id={category} role="tabpanel" aria-labelledby="erp-integrations-tab">
                                        <IntegrationsSetupList
                                            providers={providersByCategories[category]}
                                            storeUrl={props.storeUrl}
                                            fetchData={fetchData}
                                            updateUrl={props.updateUrl}
                                            testConnectionUrl={props.testConnectionUrl}
                                            checkConnectivityUrl={props.checkConnectivityUrl}
                                        />
                                    </div>
                                )}
                            </Fragment>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

if (document.getElementById('integrationsSetupList')) {
    const rootEl = document.getElementById('integrationsSetupList');
    ReactDOM.render(
        <App>
            <IntegrationsSetupIndex
                fetchUrl={fetchUrl}
                storeUrl={storeUrl}
                updateUrl={updateUrl}
                testConnectionUrl={testConnectionUrl}
                checkConnectivityUrl={checkConnection}
            />
        </App>,
        rootEl,
    );
}
